module.exports = __webpack_public_path__ + "static/media/plane(26).9c7ee535.PNG";